export default __webpack_public_path__ + "static/media/sort-asc.fed801de.svg";